import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/banner2/registration-icon.png'
import _imports_1 from '../../assets/img/step/step-top.svg'
import _imports_2 from '../../assets/img/step/step-ico.svg'
import _imports_3 from '../../assets/img/tradingSystem/new-tag.png'
import _imports_4 from '../../assets/img/bidEvaluationTools/time.png'
import _imports_5 from '../../assets/img/tradingSystem/npapp.png'
import _imports_6 from '../../assets/img/delstep.svg'
import _imports_7 from '../../assets/img/addstep.svg'
import _imports_8 from '../../assets/img/tradingSystem/noimg.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-51967426"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-51967426><div class=\"banner-center\" data-v-51967426><div class=\"textbox\" data-v-51967426><div class=\"banner-text1\" data-v-51967426>互联远程异地项目登记工具</div><div class=\"banner-text2\" data-v-51967426>助力建设全国统一大市场，优化市场营商环境</div></div><div data-v-51967426><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-51967426></div></div></div>", 1)
const _hoisted_2 = { class: "box1" }
const _hoisted_3 = { class: "stepbox" }
const _hoisted_4 = { class: "stepitembg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_6 = { class: "stepitem" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-51967426><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-51967426></div><div class=\"stepindex\" data-v-51967426>1</div><div class=\"stepico\" data-v-51967426><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-51967426></div><div class=\"stepTitle\" data-v-51967426> 阅读接入指南 </div><div class=\"stepText\" data-v-51967426> 预览、下载《远程异地评标和评标专家库共享技术标准_远程异地项目登记工具接入指南》 </div>", 5)
const _hoisted_12 = { style: {"display":"flex","margin-top":"44px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_13 = { class: "stepitembg" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_15 = { class: "stepitem" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-51967426><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-51967426></div><div class=\"stepindex\" data-v-51967426>2</div><div class=\"stepico\" data-v-51967426><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-51967426></div><div class=\"stepTitle\" data-v-51967426> 远程异地评标目录服务组件集成对接 </div><div class=\"stepText\" data-v-51967426> 运营机构联系中国招标投标公共服务平台运维实施人员集成对接远程异地评标共享目录服务组件 </div>", 5)
const _hoisted_21 = { style: {"display":"flex","margin-top":"24px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_22 = { class: "stepitembg" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_24 = { class: "stepitem" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-51967426><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-51967426></div><div class=\"stepindex\" data-v-51967426>3</div><div class=\"stepico\" data-v-51967426><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-51967426></div><div class=\"stepTitle\" data-v-51967426> 与跨省远程异地目录服务<br data-v-51967426>组件共同联调测试 </div><div class=\"stepText\" data-v-51967426> 与跨省远程异地目录服务组件共同联调测试相关接口 </div>", 5)
const _hoisted_30 = { style: {"display":"flex","margin-top":"34px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_31 = { class: "stepitembg" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"stepitem\" data-v-51967426><div class=\"step-top\" data-v-51967426><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-51967426></div><div class=\"stepindex\" data-v-51967426>4</div><div class=\"stepico\" data-v-51967426><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-51967426></div><div class=\"stepTitle\" data-v-51967426> 公开测试承诺 </div><div class=\"stepText\" data-v-51967426> 与跨省远程异地目录服务组件共同联调测试通过后，通过远程异地评标和评标专家库共享目交易中心场所自助管理终端，上传并公开测试承诺书和自主测试报告，自助加入远程异地项目登记工具互联目录 </div></div>", 1)
const _hoisted_34 = { class: "stepitembg" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_36 = { class: "stepitem" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-51967426><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-51967426></div><div class=\"stepindex\" data-v-51967426>5</div><div class=\"stepico\" data-v-51967426><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-51967426></div><div class=\"stepTitle\" data-v-51967426> 交易系统集成远程异地项目登记工具 </div><div class=\"stepText\" data-v-51967426> 预览、下载《远程异地评标和评标专家库共享技术标准_集成远程异地项目登记工具接入指南》，交易系统集成远程异地项目登记工具。 </div>", 5)
const _hoisted_42 = { style: {"display":"flex","margin-top":"24px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"stepitembg\" data-v-51967426><div class=\"overtop\" data-v-51967426></div><div class=\"stepitem\" data-v-51967426><div class=\"step-top\" data-v-51967426><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-51967426></div><div class=\"stepindex\" data-v-51967426>6</div><div class=\"stepico\" data-v-51967426><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-51967426></div><div class=\"stepTitle\" data-v-51967426> 启动实际应用 </div><div class=\"stepText\" data-v-51967426> 交易系统正式部署上线远程异地项目登记工具后，启动实际应用。 </div></div></div><div style=\"width:288px;\" data-v-51967426></div><div style=\"width:288px;\" data-v-51967426></div>", 3)
const _hoisted_46 = { class: "box2" }
const _hoisted_47 = { class: "box2-top" }
const _hoisted_48 = { class: "search" }
const _hoisted_49 = {
  key: 0,
  class: "content"
}
const _hoisted_50 = {
  class: "platformtype-title",
  style: {"border-bottom":"1px solid #EBEBED"}
}
const _hoisted_51 = { class: "contentbox" }
const _hoisted_52 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_53 = { class: "center" }
const _hoisted_54 = ["src"]
const _hoisted_55 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_56 = { class: "center2" }
const _hoisted_57 = { class: "top2" }
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "infobox" }
const _hoisted_60 = { class: "text-box1" }
const _hoisted_61 = { class: "text-box" }
const _hoisted_62 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_64 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_65 = { class: "center" }
const _hoisted_66 = { class: "noplatform" }
const _hoisted_67 = {
  class: "platformtype-title",
  style: {"margin-top":"16px"}
}
const _hoisted_68 = { class: "municipality-title" }
const _hoisted_69 = { class: "municipality-name" }
const _hoisted_70 = { class: "municipality-total" }
const _hoisted_71 = ["onMouseenter", "onMouseleave"]
const _hoisted_72 = { style: {"position":"relative","width":"1153px","margin":"0 auto"} }
const _hoisted_73 = { class: "contentbox2" }
const _hoisted_74 = { class: "center" }
const _hoisted_75 = ["src"]
const _hoisted_76 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_77 = {
  key: 1,
  class: "cityName"
}
const _hoisted_78 = { class: "center2" }
const _hoisted_79 = { class: "top2" }
const _hoisted_80 = ["src"]
const _hoisted_81 = { class: "infobox" }
const _hoisted_82 = { class: "text-box1" }
const _hoisted_83 = { class: "text-box" }
const _hoisted_84 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_86 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_87 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_88 = { class: "center" }
const _hoisted_89 = ["src"]
const _hoisted_90 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_91 = {
  key: 1,
  class: "cityName"
}
const _hoisted_92 = { class: "center2" }
const _hoisted_93 = { class: "top2" }
const _hoisted_94 = ["src"]
const _hoisted_95 = { class: "infobox" }
const _hoisted_96 = { class: "text-box1" }
const _hoisted_97 = { class: "text-box" }
const _hoisted_98 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_100 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    class: "appimg3",
    style: {"border":"none"}
  })
], -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  style: {"width":"16px","height":"16px"}
}, null, -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = {
  key: 1,
  class: "content"
}
const _hoisted_109 = {
  key: 0,
  class: "searchBox"
}
const _hoisted_110 = ["onMouseover", "onMouseout", "onClick"]
const _hoisted_111 = { class: "center" }
const _hoisted_112 = ["src"]
const _hoisted_113 = { class: "center2" }
const _hoisted_114 = { class: "top2" }
const _hoisted_115 = ["src"]
const _hoisted_116 = { class: "infobox" }
const _hoisted_117 = { class: "text-box1" }
const _hoisted_118 = { class: "text-box" }
const _hoisted_119 = { style: {"display":"flex","align-items":"center","margin-top":"10px"} }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_121 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_122 = {
  key: 2,
  class: "nodata"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "",
  style: {"width":"80px","height":"80px"}
}, null, -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text1" }, "暂无内容", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text2" }, "没有搜到想要的内容？您可 联系我们 进行咨询", -1))
const _hoisted_126 = [
  _hoisted_123,
  _hoisted_124,
  _hoisted_125
]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"66px","width":"100px"} }, null, -1))
const _hoisted_128 = { class: "dialogtitle" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dtext" }, "选择交易平台或系统查看", -1))
const _hoisted_130 = { class: "numbox" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dline" }, null, -1))
const _hoisted_132 = { class: "dtext2" }
const _hoisted_133 = { class: "dtext3" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dline" }, null, -1))
const _hoisted_135 = ["onClick"]

import infoDailog from '../infoDailog.vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'
import { reactive, toRefs, ref, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";

import { getPublishPlatform, platformView, endpointDownload, documentPreview, getProvincePlatformCatalog } from '../../utils/axios'
import { ElMessage } from 'element-plus';




import { Swiper, SwiperSlide } from 'swiper/vue'; // swiper所需组件
// 这是分页器和对应方法，swiper好像在6的时候就已经分离了分页器和一些其他工具
import { Autoplay, Navigation, A11y } from 'swiper';
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import 'swiper/css';
import 'swiper/css/navigation';
//默认滑动效果（这里面注释掉的可以不要）
// const onSwiper = swiper => {
// };
// const onSlideChange = e => {
// 	// swiper切换的时候执行的方法
// };
// setup语法糖只需要这样创建一个变量就可以正常使用分页器和对应功能，如果没有这个数组则无法使用对应功能

export default /*#__PURE__*/_defineComponent({
  __name: 'remoteRegistrationTool',
  setup(__props) {



const route = useRoute()
const router = useRouter();
const modules = [Autoplay, Navigation, A11y];

let showContactUs1 = ref(false)
let showContactUs2 = ref(false)


//  平台轮播按钮
const navigation = ref({
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
});

//上一个
const prevEl = (item, index) => {
};
//下一个
const nextEl = () => {
};








//  平台弹框

let showRegister = ref(false)
let registrationType = ref(-1)
//  打开平台弹框

const openDialog = (type) => {
  if(type == 1){
    console.log(window._czc)
      window._czc.push(['_trackEvent', '交易中心', '联系我们', '部署远程异地评标目录服务组件'])
  }else{
      window._czc.push(['_trackEvent', '交易中心', '联系我们', '部署评标专家库目录服务组件'])
  }
  
  // showRegister.value = true
  // canDownload()
}
const clickdialog = () => {

}
// 跳转视频
const tovideo = () => {
  window.open('https://www.yunpan.com/surl_y9tqAvIvstR', '_blank')

}
//下载工具
const downTool = (type) => {

  if (type == 6) {
      window.open('https://d45a52.link.yunpan.com/lk/surl_y9ktHkJQ6Kr', '_blank')
  }

  if (type == 7) {
      window.open('https://d45a52.link.yunpan.com/lk/surl_y9ktHkJQ6Kr', '_blank')

  }

  if (type == 8) {
      // ElMessage.warning('功能开发中，敬请期待！')
      window.open('http://casharecolumn.oss-cn-beijing.aliyuncs.com/zz-ca-share-column/upload/20240830/44aaa506f31c2eac5206f9e7a32f0f66.zip', '_blank')
  }

}
//源码预览
const toymUrl = (type) => {
  // ElMessage.warning('功能开发中，敬请期待！')
  window.open('https://gitee.com/cebpubservice', '_blank')

}
//关闭弹框
const confirm = () => {
  showRegister.value = false

}

const canDownload = () => {

}


//预览 并发送友盟统计
const Previewzn = (type: any,type2:any) => {
  // ElMessage.warning('功能开发中，敬请期待！')
  // documentPreview({ documentType: type }).then(res => {

  //     window.open(res.data.documentUrl, '_blank');
  // }).catch(res => {
  //     ElMessage.warning('功能开发中，敬请期待！')
  // })

  if (type2 == '1') {
    window._czc.push(['_trackEvent', '远程异地评标项目', '预览', '登记工具接入指南预览'])
    window.open('T01远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南_20250605_1600.pdf', '_blank');
  }

  if (type2 == '2') {
    window._czc.push(['_trackEvent', '远程异地评标项目', '准备环境', '登记工具接入指南预览'])
    window.open('T01远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南_20250605_1600.pdf', '_blank');
  }

  if (type2 == '3') {
    window._czc.push(['_trackEvent', '集成远程异地项目', '预览', '登记工具接入指南预览'])
    window.open('S07远程异地评标和评标专家库共享技术标准_集成远程异地项目登记工具接入指南_20250605_1600.pdf', '_blank');
  }
}



//下载 并发送友盟统计

const downzn = (type: any,type2:any) => {
  let url = ''
  if (type2 == '1') {
    window._czc.push(['_trackEvent', '远程异地评标项目', '下载', '登记工具接入指南预览'])
    url = 'T01远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南_20250605_1600.pdf'
  }

  if (type2 == '2') {
    window._czc.push(['_trackEvent', '集成远程异地项目', '准备环境', '登记工具接入指南预览'])
    url = 'T01远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南_20250605_1600.pdf'
  }

  if (type2 == '3') {
    window._czc.push(['_trackEvent', '集成远程异地项目', '下载', '登记工具接入指南预览'])
    url = 'S07远程异地评标和评标专家库共享技术标准_集成远程异地项目登记工具接入指南_20250605_1600.pdf'
  }


  const a = document.createElement('a')
  a.href = url
  a.download = url
  a.click()

}



// 跳转自主模拟测试

const tosharedComponents = (type) => {

  if (type == '1') {
      window.open('http://47.93.12.150/mocktest/', '_blank')
  }
  if (type == '2') {
      window.open('', '_blank')
  }
}

onMounted(async () => {
  await nextTick(); // 等待 DOM 更新  
  if (route.query.bottom) {
      // 滚动到距离页面顶部800px的位置  
      window.scrollTo({
          top: 900,
          behavior: 'smooth' // 可选，用于平滑滚动  
      });
  } else {
      window.scrollTo(0, 0);
  }

  //获取平台列表
  // getalllist()
//   noreginList.value = reginList.value
  let aa = JSON.parse(JSON.stringify(reginList.value))
  aa.map(item => {
      item.platformList = []
  }
  )
  cityList.value = aa





});


//地级市
let reginList = ref(
  [
      {
          "id": 11,
          "parentId": 0,
          "title": "北京市",
          "key": "11",
          "value": "11",
          "hasChildren": true
      },
      {
          "id": 12,
          "parentId": 0,
          "title": "天津市",
          "key": "12",
          "value": "12",
          "hasChildren": true
      },
      {
          "id": 13,
          "parentId": 0,
          "title": "河北省",
          "key": "13",
          "value": "13",
          "hasChildren": true
      },
      {
          "id": 14,
          "parentId": 0,
          "title": "山西省",
          "key": "14",
          "value": "14",
          "hasChildren": true
      },
      {
          "id": 15,
          "parentId": 0,
          "title": "内蒙古",
          "key": "15",
          "value": "15",
          "hasChildren": true
      },
      {
          "id": 21,
          "parentId": 0,
          "title": "辽宁省",
          "key": "21",
          "value": "21",
          "hasChildren": true
      },
      {
          "id": 22,
          "parentId": 0,
          "title": "吉林省",
          "key": "22",
          "value": "22",
          "hasChildren": true
      },
      {
          "id": 23,
          "parentId": 0,
          "title": "黑龙江省",
          "key": "23",
          "value": "23",
          "hasChildren": true
      },
      {
          "id": 31,
          "parentId": 0,
          "title": "上海市",
          "key": "31",
          "value": "31",
          "hasChildren": true
      },
      {
          "id": 32,
          "parentId": 0,
          "title": "江苏省",
          "key": "32",
          "value": "32",
          "hasChildren": true
      },
      {
          "id": 33,
          "parentId": 0,
          "title": "浙江省",
          "key": "33",
          "value": "33",
          "hasChildren": true
      },
      {
          "id": 34,
          "parentId": 0,
          "title": "安徽省",
          "key": "34",
          "value": "34",
          "hasChildren": true
      },
      {
          "id": 35,
          "parentId": 0,
          "title": "福建省",
          "key": "35",
          "value": "35",
          "hasChildren": true
      },
      {
          "id": 36,
          "parentId": 0,
          "title": "江西省",
          "key": "36",
          "value": "36",
          "hasChildren": true
      },
      {
          "id": 37,
          "parentId": 0,
          "title": "山东省",
          "key": "37",
          "value": "37",
          "hasChildren": true
      },
      {
          "id": 41,
          "parentId": 0,
          "title": "河南省",
          "key": "41",
          "value": "41",
          "hasChildren": true
      },
      {
          "id": 42,
          "parentId": 0,
          "title": "湖北省",
          "key": "42",
          "value": "42",
          "hasChildren": true
      },
      {
          "id": 43,
          "parentId": 0,
          "title": "湖南省",
          "key": "43",
          "value": "43",
          "hasChildren": true
      },
      {
          "id": 44,
          "parentId": 0,
          "title": "广东省",
          "key": "44",
          "value": "44",
          "hasChildren": true
      },
      {
          "id": 46,
          "parentId": 0,
          "title": "海南省",
          "key": "46",
          "value": "46",
          "hasChildren": true
      },
      {
          "id": 45,
          "parentId": 0,
          "title": "广西",
          "key": "45",
          "value": "45",
          "hasChildren": true
      },

      {
          "id": 50,
          "parentId": 0,
          "title": "重庆市",
          "key": "50",
          "value": "50",
          "hasChildren": true
      },
      {
          "id": 51,
          "parentId": 0,
          "title": "四川省",
          "key": "51",
          "value": "51",
          "hasChildren": true
      },
      {
          "id": 52,
          "parentId": 0,
          "title": "贵州省",
          "key": "52",
          "value": "52",
          "hasChildren": true
      },
      {
          "id": 53,
          "parentId": 0,
          "title": "云南省",
          "key": "53",
          "value": "53",
          "hasChildren": true
      },
      {
          "id": 54,
          "parentId": 0,
          "title": "西藏",
          "key": "54",
          "value": "54",
          "hasChildren": true
      },
      {
          "id": 61,
          "parentId": 0,
          "title": "陕西省",
          "key": "61",
          "value": "61",
          "hasChildren": true
      },
      {
          "id": 62,
          "parentId": 0,
          "title": "甘肃省",
          "key": "62",
          "value": "62",
          "hasChildren": true
      },
      {
          "id": 63,
          "parentId": 0,
          "title": "青海省",
          "key": "63",
          "value": "63",
          "hasChildren": true
      },
      {
          "id": 64,
          "parentId": 0,
          "title": "宁夏",
          "key": "64",
          "value": "64",
          "hasChildren": true
      },
      {
          "id": 65,
          "parentId": 0,
          "title": "新疆",
          "key": "65",
          "value": "65",
          "hasChildren": true
      },


      {
          "id": 99,
          "parentId": 0,
          "title": "新疆兵团",
          "key": "99",
          "value": "99",
          "hasChildren": true
      },


  ])


//地级市
let noreginList = ref([])

//省级
let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: "李炜",
      platformContactPhone: "13886032676",
      platformLogo: require("@/assets/img/image.png"),
      createUserName: "",
      updateUserName: "",
      createTime: "2025/3/30 18:30:56",
      platformRegionName: "湖北省",
    },
  },
])
noreginList.value = reginList.value.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);
let cityList = ref([{ platformList: [] }])


//总数
let total = ref(0)


let PlatformParms = ref({
  platformName: '',
})




//搜索平台列表
let searchPlatform = ref([])

//是否搜索
let isSearch = ref(false)
//是否显示更多按钮
let showmoreBtn = ref(false)
//当前页数
let currentPage = ref(1)
//搜索平台列表方法
const getalllist = (platformName) => {
  let nowUrl = window.location.href
  // 搜索
  if (platformName) {
      isSearch.value = true
      let parms = {
          platformName: platformName,
          current: 1,
          size: 12,
          ascs: 'create_time',
      }
      showmoreBtn.value = false
      getPublishPlatform(parms).then(res => {
          searchPlatform.value = res.data.records




          // if (nowUrl.includes('cashare.cebpubservice.com')){
          //     //生产环境置空
          //     searchPlatform.value = []
          // }


          // searchPlatform.value = []
          searchPlatform.value.map(item => {
              item.isHovered = false
          })

          if (res.data.total > res.data.size * res.data.current) {
              showmoreBtn.value = true
          }
          currentPage.value = res.data.current

      })


  } else {
      // 初始化
      getProvincePlatformCatalog({}).then(res => {
          isSearch.value = false

          platformList.value = res.data.provinceList

          // platformList.value = []


          // if (nowUrl.includes('cashare.cebpubservice.com')){
          //     //生产环境置空
          //    platformList.value = []
          // }



          let filteredList1 = reginList.value.filter(item => !platformList.value.some(item2 => item2.provinceCode == item.key));

          noreginList.value = filteredList1



          platformList.value.map((item: any) => {
              res.data.latestProvincePlatformIdList.map(item3 => {
                  //省级最新标签
                  if (item3 == item.firstPlatform.id) {
                      item.isNew = true

                  }

              })
          })


          cityList.value = JSON.parse(JSON.stringify(reginList.value))
          let mergedCityList = cityList.value.map((item: any) => {
              // 查找 res.data.cityList 中与当前 item.value 相等的 provinceCode  
              const match = res.data.cityList.find((item2: any) => item.value === item2.provinceCode);
              // 如果找到了匹配项，则合并两个对象  
              if (match) {
                  // 使用扩展运算符 {...} 来合并对象  
                  return { ...item, ...match };
              }
              // 如果没有找到匹配项，则返回原始对象  
              return item;
          });


          cityList.value = mergedCityList

          // if (nowUrl.includes('cashare.cebpubservice.com')){
          //     //生产环境置空
          //     cityList.value= cityList.value

          // }else{
          //     cityList.value = mergedCityList

          // }





          cityList.value.map((item) => {
              if (!item.platformList) {
                  item.platformList = []
              }

              if (item.platformList) {
                  total.value = total.value + item.platformList.length
                  if (item.platformList.length > 0) {
                      item.platformList[item.platformList.length - 1].isNew = true

                  }
              }




          })



          cityList.value = cityList.value.filter(item => item.id !== 99);











      })
  }




}
//展示城市名称
const showcity = (address) => {
  if (address) {
      // 按照逗号分割字符串  
      const parts = address.split(',');
      // 检查是否有足够的部分来包含市级  
      if (parts.length >= 2) {
          // 返回第二个部分（市级），并去除可能存在的空格  
          return parts[1].trim();
      } else {
          return parts[0].trim(); // 或者你可以决定返回null/''来表示错误  
      }
  } else {
      return ''
  }

}

//查看更多，下一页
const addPage = (platformName) => {
  isSearch.value = true

  let parms = {
      platformName: platformName,
      current: currentPage.value + 1,
      size: 12,
      ascs: 'create_time',
  }
  showmoreBtn.value = false
  getPublishPlatform(parms).then(res => {
      searchPlatform.value = [...searchPlatform.value, ...res.data.records]
      searchPlatform.value.map(item => {
          item.isHovered = false
          item.isHovered2 = false
      })

      if (res.data.total > res.data.size * res.data.current) {
          showmoreBtn.value = true
      } else {
          showmoreBtn.value = false
      }

      currentPage.value = res.data.current

  })
}


//控制弹框
let showoverlay = ref(false)
//平台信息
let systeminfo = ref({ systemList: [{ tradingSystemName: '' },] })
//点击,判断只有一个平台跳转平台,多个平台弹框
const toPlatform = (item) => {
  if (item.systemList.length > 1) {
      showoverlay.value = true
      systeminfo.value = item
  } else {
      window.open(item.systemList[0].tradingSystemUrl, '_blank')
  }

}
// 跳转平台
const toPlatformUrl = (item) => {
  window.open(item.tradingSystemUrl, '_blank')
}


//跳转共享组件页面
const toSharedComponents = (tip) => {
  router.push({
      path: '/sharedComponents',
      query: {
          tip: tip
      }
  })
}











return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(mytitle, {
          title: "对接实施具体步骤",
          style: {"margin-top":"64px"}
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_button, {
                  class: "btn2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (Previewzn(1,1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("预览")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (downzn(1,1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_button, {
                  class: "btn2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (Previewzn(1,2)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("预览")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (downzn(1,2)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createVNode(contactUs, null, null, 512), [
              [_vShow, _unref(showContactUs1)]
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_button, {
                  class: "btn2",
                  style: {"width":"256px"},
                  onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showContactUs1) //@ts-ignore
 ? showContactUs1.value = true : showContactUs1 = true)),
                  onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showContactUs1) //@ts-ignore
 ? showContactUs1.value = false : showContactUs1 = false)),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (openDialog(1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("联系我们")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createVNode(contactUs, null, null, 512), [
              [_vShow, _unref(showContactUs2)]
            ]),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_el_button, {
                  class: "btn2",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (Previewzn(1,3)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("预览")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn1",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (downzn(1,3)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _hoisted_43
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createVNode(mytitle, {
            title: "互联远程异地项目登记工具目录",
            color: "white",
            style: {"margin-top":"64px"}
          }),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_el_input, {
              modelValue: _unref(PlatformParms).platformName,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(PlatformParms).platformName) = $event)),
              placeholder: "请输入远程异地项目登记工具名称搜索",
              class: "paperview-input-text"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "searchbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            })
          ])
        ]),
        (!_unref(isSearch))
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, "省级（" + _toDisplayString(_unref(platformList).length) + "） ", 1),
              _createElementVNode("div", _hoisted_51, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformList), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onMouseover: ($event: any) => (item.isHovered = true),
                    onMouseout: ($event: any) => (item.isHovered = false),
                    onClick: ($event: any) => (toPlatform(item.firstPlatform)),
                    style: {"cursor":"pointer"}
                  }, [
                    _withDirectives(_createElementVNode("div", _hoisted_53, [
                      _createElementVNode("img", {
                        src: item.firstPlatform.platformLogo,
                        alt: "",
                        class: "appimgbox"
                      }, null, 8, _hoisted_54),
                      (item.isNew)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, !item.isHovered]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("img", {
                          src: item.firstPlatform.platformLogo,
                          alt: "",
                          class: "appimgn"
                        }, null, 8, _hoisted_58)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, _toDisplayString(item.firstPlatform.platformContactName), 1),
                        _createElementVNode("div", _hoisted_61, _toDisplayString(item.firstPlatform.platformContactPhone), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("span", _hoisted_64, _toDisplayString(item.firstPlatform.createTime), 1)
                      ])
                    ], 512), [
                      [_vShow, item.isHovered]
                    ])
                  ], 40, _hoisted_52))
                }), 256)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noreginList), (n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"cursor":"pointer"},
                    key: n
                  }, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, _toDisplayString(n.title), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_67, "地级市（" + _toDisplayString(_unref(total)) + "）", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, _toDisplayString(item.provinceName ? item.provinceName : item.title), 1),
                    _createElementVNode("div", _hoisted_70, " 共加入 " + _toDisplayString(item.platformList.length) + " 家", 1)
                  ]),
                  _createElementVNode("div", {
                    style: {"width":"1200px","margin-left":"-27px"},
                    onMouseenter: ($event: any) => (item.isHovered2 = true),
                    onMouseleave: ($event: any) => (item.isHovered2 = false)
                  }, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        (item.platformList.length > 6)
                          ? (_openBlock(), _createBlock(_unref(Swiper), {
                              key: 0,
                              slidesPerView: 6,
                              spaceBetween: 0,
                              autoplay: {
                              delay: 2500,
                              disableOnInteraction: false
                          },
                              loop: true,
                              navigation: navigation.value,
                              modules: modules,
                              class: "mySwiper"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platformList, (item2, index) => {
                                  return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                                    onMouseover: ($event: any) => (item2.isHovered = true),
                                    key: index,
                                    onMouseout: ($event: any) => (item2.isHovered = false),
                                    onClick: ($event: any) => (toPlatform(item2)),
                                    style: {"cursor":"pointer"}
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("img", {
                                          src: item2.platformLogo,
                                          alt: "",
                                          class: "appimgbox"
                                        }, null, 8, _hoisted_75),
                                        (item2.isNew)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                                          : _createCommentVNode("", true),
                                        (showcity(item2.platformRegionName))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(showcity(item2.platformRegionName)), 1))
                                          : _createCommentVNode("", true)
                                      ], 512), [
                                        [_vShow, !item2.isHovered]
                                      ]),
                                      _withDirectives(_createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                          _createElementVNode("img", {
                                            src: item2.platformLogo,
                                            alt: "",
                                            class: "appimgn"
                                          }, null, 8, _hoisted_80)
                                        ]),
                                        _createElementVNode("div", _hoisted_81, [
                                          _createElementVNode("div", _hoisted_82, _toDisplayString(item2.platformContactName), 1),
                                          _createElementVNode("div", _hoisted_83, _toDisplayString(item2.platformContactPhone), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_84, [
                                          _hoisted_85,
                                          _createElementVNode("span", _hoisted_86, _toDisplayString(item2.createTime), 1)
                                        ])
                                      ], 512), [
                                        [_vShow, item2.isHovered]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onMouseover", "onMouseout", "onClick"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["navigation"]))
                          : _createCommentVNode("", true),
                        (item.platformList.length <= 6)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.platformList, (item2, index2) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index2,
                                onMouseover: ($event: any) => (item2.isHovered = true),
                                onMouseout: ($event: any) => (item2.isHovered = false),
                                onClick: ($event: any) => (toPlatform(item2)),
                                style: {"cursor":"pointer"}
                              }, [
                                _withDirectives(_createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("img", {
                                    src: item2.platformLogo,
                                    alt: "",
                                    class: "appimgbox"
                                  }, null, 8, _hoisted_89),
                                  (item2.isNew)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_90))
                                    : _createCommentVNode("", true),
                                  (showcity(item2.platformRegionName))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(showcity(item2.platformRegionName)), 1))
                                    : _createCommentVNode("", true)
                                ], 512), [
                                  [_vShow, !item2.isHovered]
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("div", _hoisted_93, [
                                    _createElementVNode("img", {
                                      src: item2.platformLogo,
                                      alt: "",
                                      class: "appimgn"
                                    }, null, 8, _hoisted_94)
                                  ]),
                                  _createElementVNode("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, _toDisplayString(item2.platformContactName), 1),
                                    _createElementVNode("div", _hoisted_97, _toDisplayString(item2.platformContactPhone), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_98, [
                                    _hoisted_99,
                                    _createElementVNode("span", _hoisted_100, _toDisplayString(item2.createTime), 1)
                                  ])
                                ], 512), [
                                  [_vShow, item2.isHovered]
                                ])
                              ], 40, _hoisted_87))
                            }), 128))
                          : _createCommentVNode("", true),
                        (item.platformList.length < 6)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(6, (item2, index3) => {
                              return _createElementVNode("div", {
                                key: index3,
                                style: {"cursor":"pointer"}
                              }, _hoisted_102)
                            }), 64))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("div", {
                        class: "swiper-button-prev",
                        onClick: _withModifiers(($event: any) => (prevEl(item, index)), ["stop"])
                      }, [
                        _createElementVNode("div", {
                          class: "delStep",
                          style: {"position":"absolute","left":"-35px","top":"5px"},
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.prevCarousel && _ctx.prevCarousel(...args)))
                        }, _hoisted_105)
                      ], 8, _hoisted_103), [
                        [_vShow, item.platformList.length > 6 && item.isHovered2]
                      ]),
                      _withDirectives(_createElementVNode("div", {
                        class: "swiper-button-next swiper-button-next1",
                        onClick: _withModifiers(nextEl, ["stop"])
                      }, [
                        _createElementVNode("div", {
                          class: "delStep",
                          style: {"position":"absolute","right":"-35px","top":"5px"},
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addstep && _ctx.addstep(...args)))
                        }, _hoisted_107)
                      ], 512), [
                        [_vShow, item.platformList.length > 6 && item.isHovered2]
                      ])
                    ])
                  ], 40, _hoisted_71)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_unref(isSearch))
          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
              (_unref(searchPlatform).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchPlatform), (item2, index2) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index2,
                        onMouseover: ($event: any) => (item2.isHovered = true),
                        onMouseout: ($event: any) => (item2.isHovered = false),
                        onClick: ($event: any) => (toPlatform(item2)),
                        style: {"cursor":"pointer"}
                      }, [
                        _withDirectives(_createElementVNode("div", _hoisted_111, [
                          _createElementVNode("img", {
                            src: item2.platformLogo,
                            alt: "",
                            class: "appimgbox"
                          }, null, 8, _hoisted_112)
                        ], 512), [
                          [_vShow, !item2.isHovered]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_113, [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("img", {
                              src: item2.platformLogo,
                              alt: "",
                              class: "appimgn"
                            }, null, 8, _hoisted_115)
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, _toDisplayString(item2.platformContactName), 1),
                            _createElementVNode("div", _hoisted_118, _toDisplayString(item2.platformContactPhone), 1)
                          ]),
                          _createElementVNode("div", _hoisted_119, [
                            _hoisted_120,
                            _createElementVNode("span", _hoisted_121, _toDisplayString(item2.createTime), 1)
                          ])
                        ], 512), [
                          [_vShow, item2.isHovered]
                        ])
                      ], 40, _hoisted_110))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(showmoreBtn))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "btnmore",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (addPage(_unref(PlatformParms).platformName)))
                  }, " 查看更多 "))
                : _createCommentVNode("", true),
              (_unref(searchPlatform).length < 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, _hoisted_126))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_127,
      _createVNode(infoDailog, {
        showRegister: _unref(showRegister),
        registrationType: _unref(registrationType),
        onConfirm: confirm,
        onCanDownload: canDownload
      }, null, 8, ["showRegister", "registrationType"])
    ]),
    (_unref(showoverlay))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "myoverlay",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(showoverlay) //@ts-ignore
 ? showoverlay.value = false : showoverlay = false))
        }, [
          _createElementVNode("div", {
            class: "mydialog",
            onClick: _withModifiers(clickdialog, ["stop"])
          }, [
            _createElementVNode("div", _hoisted_128, _toDisplayString(_unref(systeminfo).platformName), 1),
            _hoisted_129,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_130, [
                _hoisted_131,
                _createElementVNode("div", _hoisted_132, [
                  _createTextVNode("交易系统 "),
                  _createElementVNode("span", _hoisted_133, _toDisplayString(_unref(systeminfo).systemList.length), 1),
                  _createTextVNode(" 个")
                ]),
                _hoisted_134
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["systeminfoBox", { 'systeminfoBox2': _unref(systeminfo).systemList.length === 2 }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(systeminfo).systemList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "systemItem",
                    key: index,
                    onClick: ($event: any) => (toPlatformUrl(item))
                  }, _toDisplayString(item.tradingSystemName), 9, _hoisted_135))
                }), 128))
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})